export const createSizeText = (sizeText: string, isWaist: boolean) => {
  const localeValue = sizeText.split(' ')[0];
  const waistValue = sizeText.split(' ')[1];
  const lengthValue = sizeText.split(' ')[2];

  if (localeValue && waistValue && lengthValue) {
    return isWaist
      ? `${localeValue}${waistValue.replace('W', ' ')}`
      : `${localeValue}${lengthValue.replace('L', ' ')}`;
  }

  return '';
};
